import * as React from "react";

import { Skeleton, Typography } from "mpulse-design-system";
import { Grid } from "@mui/material";

const AccountCardDetails = ({
  Icon,
  fetching,
  totalItemTitle,
  totalItemCount,
  firstItemTitle,
  firstItemCount,
  secondItemTitle,
  secondItemCount,
}) => {
  return (
    <Grid item container xxs={5.5} direction="column" rowSpacing={3}>
      <Grid item container direction="row" spacing={0}>
        <Grid item container sm={12}>
          <Grid item lg={9} mlg={10} sm={10}>
            <Typography variant="h4" color="textPrimary">
              {totalItemTitle}
            </Typography>
          </Grid>
          <Grid item sm>
            <Icon sx={{ color: (theme) => theme.palette.grey[700] }} />
          </Grid>
        </Grid>
        <Grid item sm={12}>
          <Typography
            variant="overline"
            color="textPrimary"
            sx={{ color: (theme) => theme.palette.grey[550] }}
          >
            {fetching ? <SkeletonStyled /> : `${totalItemCount} Items`}
          </Typography>
        </Grid>
      </Grid>
      <Grid item container direction="column" spacing={2}>
        <Grid item container direction="column" spacing={0}>
          <Grid item>
            <Typography variant="body1" color="textPrimary">
              {firstItemTitle}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              variant="overline"
              sx={{ color: (theme) => theme.palette.grey[550] }}
            >
              {fetching ? <SkeletonStyled /> : `${firstItemCount} Items`}
            </Typography>
          </Grid>
        </Grid>
        <Grid item container direction="column" spacing={0}>
          <Grid item>
            <Typography variant="body1" color="textPrimary">
              {secondItemTitle}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              variant="overline"
              sx={{ color: (theme) => theme.palette.grey[550] }}
            >
              {fetching ? <SkeletonStyled /> : `${secondItemCount} Items`}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const SkeletonStyled = () => {
  return <Skeleton width={60} height={20} />;
};

export default AccountCardDetails;
